import React, { useState, useRef } from "react";
import { toast } from "sonner";
import Landing from "../components/Landing";
import ConversationalSurvey from "../components/ConversationalSurvey";
import ResultPage from "../components/ResultPage";
import { emptyForm } from "../mock";
import { submitSurvey, createSession, updateSession } from "../api";

// stage: "landing" | "survey" | "result"
export default function Questionnaire() {
  const [stage, setStage] = useState("landing");
  const [form, setForm] = useState({ ...emptyForm });
  const [result, setResult] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const sessionId = useRef(null);

  const startSurvey = async () => {
    setForm({ ...emptyForm });
    setStage("survey");
    window.scrollTo({ top: 0 });
    try {
      const res = await createSession();
      sessionId.current = res.id;
    } catch {
      sessionId.current = null;
    }
  };

  // 逐題記錄進度（追蹤未完成）
  const handleProgress = (currentForm, currentQuestion, progress) => {
    if (!sessionId.current) return;
    const { emailConfirm, ...data } = currentForm;
    updateSession(sessionId.current, { data, currentQuestion, progress }).catch(() => {});
  };

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const { email, emailConfirm, ...rest } = form;
      const res = await submitSurvey({ ...rest, email, sessionId: sessionId.current });
      setResult(res.status);
      setStage("result");
      toast.success("問卷已送出！評估結果已寄至你的信箱");
      window.scrollTo({ top: 0 });
    } catch (e) {
      toast.error("送出失敗，請稍後再試");
    } finally {
      setSubmitting(false);
    }
  };

  const restart = () => {
    setStage("landing");
    window.scrollTo({ top: 0 });
  };

  if (stage === "landing") return <Landing onStart={startSurvey} />;
  if (stage === "result")
    return <ResultPage status={result} onRestart={restart} />;

  return (
    <ConversationalSurvey
      form={form}
      setForm={setForm}
      onBack={() => setStage("landing")}
      onSubmit={handleSubmit}
      submitting={submitting}
      onProgress={handleProgress}
    />
  );
}
